import { Spin } from "antd";

type Props = {
  hideText?: boolean;
};

export default function Loader({ hideText = false }: Props) {
  return (
    <div className="h-14">
      <Spin
        className="w-full py-8"
        tip={!hideText && "Loading..."}
        size="default"
      >
        <span />
      </Spin>
    </div>
  );
}
